import { Typography } from '@mui/material';
import React from 'react';
import Dashboard from 'types/entities/Dashboard';

const OverdueByCell = React.memo((row: Dashboard) => (
  <Typography noWrap variant="body2">
    {row.overdue_by ?? ''}
  </Typography>
));

export default OverdueByCell;
